
import ContentCopySharp from '@mui/icons-material/ContentCopySharp';
import CheckSharp from '@mui/icons-material/CheckSharp';
import { PropsWithChildren, useState } from 'react';

const ToastCopyContent = (props: PropsWithChildren<{ text: string }>) => {

    const [isCopied, setIsCopied] = useState(false);

    return (
        <div className='toaster-message-wrapper'>
            <div className='toaster-message' dangerouslySetInnerHTML={{ __html: props.text }}></div>
            <div className='toaster-copy-btn' >
                <span
                    title={isCopied ? 'Hata mesajı kopyalandı' : 'Koplaya'}
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                        navigator.clipboard.writeText(props.text.replace(/<(.|\n)*?>/g, ''));
                        setIsCopied(true);
                    }}>
                    {!isCopied ? <ContentCopySharp /> : <CheckSharp />}
                </span>
            </div>
        </div>
    );
}

export default ToastCopyContent